import './globals'
import '@fancyapps/fancybox'

$('[data-fancybox]').fancybox({
    touch: false,
    btnTpl: {
        smallBtn: `
            <button data-fancybox-close class="fancybox-button fancybox-close-small">
                <i class="icon-close icon-m"></i>
            </button>
        `
    },
    beforeLoad: function () {
        $(_fixedElements).each(function (index, el) {
            $(el).addClass('compensate-for-scrollbar');
        })
    },
    afterClose: function () {
        $(_fixedElements).each(function (index, el) {
            $(el).removeClass('compensate-for-scrollbar');
        })
    }
});

$('[data-fancybox="product"]').fancybox({
    touch: false,
    animationEffect: "fade",
    btnTpl: {
        smallBtn: `
            <button data-fancybox-close class="fancybox-button fancybox-close-small">
                <i class="icon-close icon-m"></i>
            </button>
        `
    },
    beforeLoad: function () {
        $(_fixedElements).each(function (index, el) {
            $(el).addClass('compensate-for-scrollbar');
        })
    },
    afterClose: function () {
        $(_fixedElements).each(function (index, el) {
            $(el).removeClass('compensate-for-scrollbar');
        })
    }
});